import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerInsumosPrecisao = styled(motion.div)`
    --green-precision: #6db68e;
    /* --green-precision: #8bcf6b; */
    width: calc(50% - 20px);
    height: calc(50vh - 40px);
    max-width: 74%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    overflow: hidden; /* Ensure content doesn't spill out */

    &[data-segmento="Sementes"] {
        width: calc(100% - 330px);
        height: 100%;
        min-width: 520px;
    }

    @media (max-width: 1120px) {
        &[data-segmento="Sementes"] {
            width: 99%;
            min-width: 99%;
        }
    }

    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }

    div.ContainerInsumosPrecisao__header {
        width: 100%;
        height: 25px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 5px;
        align-items: flex-start;
        overflow: hidden;

        p.ContainerInsumosPrecisao__title {
            font-weight: 600;
            color: var(--text-color);
            width: auto;
            font-size: 14px;
            margin: 0;
            padding: 0;
        }

        div.ContainerInsumosPrecisao__header__ref {
            display: flex;
            gap: 10px;

            div.ContainerInsumosPrecisao__header__ref__item {
                display: flex;
                align-items: center;
                gap: 5px;

                :is([data-executada]) {
                    div.ContainerInsumosPrecisao__header__ref__item__color{
                        background: var(--green-precision);
                    }

                    p.ContainerInsumosPrecisao__header__ref__item__text {
                        color: var(--green-precision);
                    }
                }

                div.ContainerInsumosPrecisao__header__ref__item__color {
                    width: 10px;
                    min-width: 10px;
                    height: 10px;
                    min-height: 10px;
                    border-radius: 2px;
                    background-color: #ccc;
                }

                p.ContainerInsumosPrecisao__header__ref__item__text {
                    font-weight: 500;
                    color: var(--text-color-light);
                    font-size: 12px;
                    margin: 0;
                    padding: 0;
                }
            }
        }
    }

    div.ContainerInsumosPrecisao__body {
        width: 100%;
        height: 100%;
        min-height: 0;
        overflow: hidden;
        /* overflow: hidden; Remove this, we need overflow-y: auto */

        /* Custom Scrollbar */
        &::-webkit-scrollbar {
            width: 5px;
        }
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #b3b3b3;
        }

        div.ContainerInsumosPrecisao__body__list__header {
            display: flex;
            align-items: center;
            gap: 15px;
            padding: 0 0 5px 0;
            margin-bottom: 5px;
            border-bottom: 1px solid #f0f0f0;

            p {
                font-size: 13px;
                font-weight: 500;
                color: var(--text-color-light);
                margin: 0;
            }

            p.ContainerInsumosPrecisao__body__list__header__title {
                /* min-width: 190px; */
                /* max-width: 190px; */
                flex: 1;
            }

            p.ContainerInsumosPrecisao__body__list__header__qtd {
                margin-left: 0; /* Removed margin-left 10px to match list item gap behavior if gap is consistent */
                min-width: 160px;
                max-width: 160px;
                text-align: center; /* Optional, depending on preference */
            }

            div.ContainerInsumosPrecisao__body__list__header__progress {
                min-width: 200px;
                max-width: 200px;
                display: flex;
                align-items: center;
                gap: 5px;
                /* width: auto; Remove flex: 1 if list item is fixed width */
                
                p.ContainerInsumosPrecisao__body__list__header__progress__title {
                     /* text-align? */
                }
            }
        }

        div.ContainerInsumosPrecisao__body__list {
            display: flex;
            flex-direction: column;
            height: calc(100% - 31px);
            overflow-y: auto;
            padding-right: 7px;

            div.ContainerInsumosPrecisao__body__list__item {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 15px;
                padding: 10px 0;
                border-bottom: 1px solid #f0f0f0;

                :hover {
                    background: var(--hover-color);
                }

                div.ContainerInsumosPrecisao__body__list__item__header {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    flex: 1;
                    min-width: 0;


                    p.ContainerInsumosPrecisao__body__list__item__title {
                        font-weight: 700;
                        color: var(--text-color);
                        font-size: 13px;
                        margin: 0;
                        /* width: calc(100% - 30px); */
                        display: flex;
                        flex: 1;
                        /* background: red; */
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-transform: capitalize;
                    }

                    div.ContainerInsumosPrecisao__body__list__item__values {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        background: blue;
                        min-width: 160px;
                        max-width: 160px;

                        span {
                            font-size: 12px;
                            font-weight: 600;
                            white-space: nowrap;
                        }

                        /* Planned Value (Left) */
                        span:nth-child(1) {
                            color: var(--text-color-light);
                            font-weight: 600;
                            padding-left: 0;
                        }
                        
                        /* Executed Value (Right) */
                        span:last-child {
                            /* background-color: var(--green-precision); */
                            color: var(--green-precision);
                            border-radius: 3px;
                        }
                    }
                }

                div.ContainerInsumosPrecisao__body__list__item__progress {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    /* flex: 1; */
                    /* width: auto; */
                    /* background: pink; */
                    min-width: 200px;
                    max-width: 200px;

                    div.ContainerInsumosPrecisao__body__list__item__progress__bar {
                        flex: 1;
                        height: 8px;
                        background-color: #f5f5f5;
                        border-radius: 15px;
                        position: relative;
                        overflow: hidden;

                        div.bar-fill {
                           height: 100%;
                           background-color: var(--green-precision);
                           border-radius: 15px;
                           z-index: 1;
                           position: relative;

                           :is([data-error = 'true']) {
                               background-color: red;
                           }

                           :is([data-warning = 'true']) {
                               background-color: #FFCC00;
                           }

                           :is([data-small = 'true']) {
                               background-color: #3e8efb;
                           }

                           :is([data-precise = 'true']) {
                               background-color: #7ebd61;
                           }
                        }
                    }

                    span {
                        font-weight: 700;
                        font-size: 12px;
                        /* color: var(--text-color); */
                        /* min-width: 30px; */
                        width: 45px;
                        min-width: 45px;
                        text-align: right;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
`;


export const QtdeContainer = styled.div`
    display: flex;
    align-items: center;
    min-width: 161px;
    max-width: 161px;
    /* background: blue; */

    div.QtdeContainer__item {
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        width: 80px;
        font-weight: 500;

        :first-child {
            text-align: right;
            padding-right: 5px;
            color: var(--text-color-light);
        }

        :last-child {
            text-align: left;
            padding-left: 5px;
            color: var(--green-precision);
            font-weight: 600;
        }
    }

    div.QtdeContainer__split {
        width: 1px;
        height: 15px;
        background-color: var(--text-color);
    }
`;